import { Salon, Stylist } from '../models'

// import { Subject } from 'rxjs';
import { Intercom } from '@capacitor-community/intercom'
import { ENV_CONFIG } from '../../bin/env.config'
import { ErrorHandlerService } from '../services/error-handler.service'
import { Auth } from '../services/login.service'
import { InAppPurchaseService } from '../services/inapp-purchase.service'
import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject } from 'rxjs'
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx'
import { StylistService } from '../services/stylist.service'
import { Utilities } from '../utilities/utilities'
import { switchMap } from 'rxjs/operators'
import { Platform } from '@ionic/angular'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
// import * as Sentry from '@sentry/angular';
// const { logger } = Sentry;

declare var intercom: any
// declare var intercom: any;
declare var $crisp: any
declare var window: any
declare var posthog: any

// export interface User {
//   user: any;
//   salon: any;
//   token: string;
// }

// declare global {
//     interface Window { $crisp: any; }
// }

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private loggedIn: boolean
  private user: Stylist
  private salon: Salon
  private token: string

  private logInMonitor = new BehaviorSubject<boolean>(false)
  private logInMonitor$ = this.logInMonitor.asObservable()
  private logOutMonitor = new BehaviorSubject<boolean>(false)
  private logOutMonitor$ = this.logOutMonitor.asObservable()
  public sessionMonitor = new BehaviorSubject<Auth>(undefined)
  private sessionMonitor$ = this.sessionMonitor.asObservable()

  private isSideBarShowing = true

  private profileImageMonitor = new BehaviorSubject<any>(null)
  public profileImageMonitor$ = this.profileImageMonitor.asObservable()

  constructor (
    private platform: Platform,
    // private stylistService: StylistService,
    // private salonService: SalonService,
    private oneSignal: OneSignal,
    protected errorHandlerService: ErrorHandlerService,
    private inAppPurchaseService: InAppPurchaseService
  ) {
    // Subscribe to session changes to update Chatwoot data
    this.sessionMonitor$.subscribe(sessionData => {
      if (sessionData && sessionData.user && sessionData.salon) {
        this.updateChatwootUser()
      }
    })
    this.platform.ready().then(() => {
      // window.$crisp=[];

      if (this.platform.is('capacitor')) {
        //   // START IN APP PURCHASE
        // this.inAppPurchaseService.init();

        //   // START One SIGNAL
        // this.oneSignal.startInit(
        //   ENV_CONFIG.oneSignalAppID,
        //   ENV_CONFIG.fireBaseSenderID
        // );

        // this.oneSignal.inFocusDisplaying(
        //   this.oneSignal.OSInFocusDisplayOption.Notification
        // );

        // this.oneSignal.handleNotificationReceived().subscribe(() => {
        //   // do something when notification is received
        // });

        // this.oneSignal.handleNotificationOpened().subscribe(() => {
        //   // do something when a notification is opened
        // });

        // this.oneSignal.endInit();
        const addNotificationReceivedListener = async () => {
          await FirebaseMessaging.addListener(
            'notificationReceived',
            event => {}
          )
        }

        const addNotificationActionPerformedListener = async () => {
          await FirebaseMessaging.addListener(
            'notificationActionPerformed',
            event => {}
          )
        }
      }
    })

    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        const authStr = localStorage.getItem('auth')
        const userStr = localStorage.getItem('user')
        const salonStr = localStorage.getItem('salon')

        if (authStr && userStr && salonStr) {
          const auth: Auth = JSON.parse(authStr)
          auth.user = JSON.parse(userStr)
          auth.salon = JSON.parse(salonStr)
          this.login(auth)
        } else {
          this.clearSession()
        }
      } catch (err) {
        this.clearSession()
      }
    } else {
      this.clearSession()
    }

    // refresh user's session immediately
    // this.refreshSession().subscribe();

    // refresh user and salon object every 15 mins
    // const fifteenMins = 1000 * 60 * 15;
    // setInterval(() => {
    //   this.refreshSession().subscribe();
    // }, fifteenMins);
  }

  // public refreshSession () : Observable<boolean> {

  //   return new Observable <boolean> (observer => {
  //     observer.next(true);
  //     observer.complete();
  //   });

  // return new Observable <boolean> (observer => {
  //   if (this.isLoggedIn()) {
  //     this.stylistService.loadStylistInfo(this.user.id)
  //       .pipe(
  //         switchMap((stylist: Stylist) => {
  //           this.setUser(stylist);
  //           return this.salonService.load();
  //         })
  //       )
  //       .subscribe((salon: Salon) => {
  //         this.setSalon(salon);

  //         this.sessionMonitor.next({
  //           user: this.user,
  //           salon: this.salon,
  //           token: undefined
  //         });

  //         observer.next(true);
  //         observer.complete();
  //       }, (err) => {
  //         observer.error(this.errorHandlerService.handleError(err));
  //         observer.complete();
  //       });
  //   } else {
  //     // observer.error(new Error('User is not logged in'));
  //     // observer.complete();
  //   }
  // });
  // }

  public login (data: Auth) {
    this.clear()
    const apiToken = data.token
    const userData = data.user
    const salonData = data.salon
    const tokenObj = JSON.parse(apiToken)
    const userID = tokenObj.user_id
    // logger.info('login in user.service.ts', {
    //   userID: userID,
    //   apiToken: apiToken,
    //   userData: userData,
    //   salonData: salonData,
    // });

    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        localStorage.setItem('auth', JSON.stringify(data))
        localStorage.setItem('token', apiToken)
        localStorage.setItem('userID', userID)
        localStorage.setItem('stylistID', userID)
        localStorage.setItem('salonID', tokenObj.salonID)
        localStorage.setItem('administrator', tokenObj.administrator)
        // Save user and salon data separately for easier access
        localStorage.setItem('user', JSON.stringify(userData))
        localStorage.setItem('salon', JSON.stringify(salonData))
      } catch (err) {
        console.error('Error saving to localStorage:', err)
      }
    }
    const user: Stylist = Stylist.parseStylistData(userData)
    const salon: Salon = Salon.parse(salonData)
    this.setUser(user)
    this.setSalon(salon)
    this.token = apiToken
    this.loggedIn = true
    this.logInMonitor.next(true)

    const stylistFullName = user.getFirstName() + ' ' + user.getLastName()
    const stylistEmail = user.getEmail()
    const appVersion = salon.getAppVersion()
    const appBuildNum = ENV_CONFIG.appVersion
    const salonName = salon.getName()
    const hasCalendar = user.getCalendar() === 1 ? 'Yes' : 'No'
    const isAdmin = user.isAdministrator() ? 'Yes' : 'No'
    const canViewAllCalendars = user.getViewAllCalendars() === 1 ? 'Yes' : 'No'
    const canViewAllClients = user.getViewAllClients() === 1 ? 'Yes' : 'No'
    const hasSettingsControl = user.getSettingsControl() === 1 ? 'Yes' : 'No'
    const requiresApptConfirmation =
      user.getConfirmApptsManually() === 1 ? 'Yes' : 'No'
    const timeZone = salon.getTimeZone()
    const country = this.salon.getCountry()
      ? this.salon.getCountry().getCountryName()
      : ''
    const readOnly = this.salon.isReadOnly() ? 'Yes' : 'No'
    const salonWebsite = this.salon.getWebsite()
    const hasStripeAccount = this.salon.hasStripeAccount() ? 'Yes' : 'No'
    const stylistID = user.getID()

    // Link user to PostHog
    // posthog.identify(this.user.getID() + '', {
    //   name: stylistFullName,
    //   email: stylistEmail,
    //   app_version: appVersion,
    //   app_build_num: appBuildNum,
    //   company_name: salonName,
    //   has_calendar: hasCalendar,
    //   hide_default_launcher: false,
    //   is_admin: isAdmin,
    //   can_view_all_calendars: canViewAllCalendars,
    //   can_view_all_clients: canViewAllClients,
    //   has_settings_control: hasSettingsControl,
    //   requires_appt_confirmation: requiresApptConfirmation,
    //   time_zone: timeZone,
    //   country: country,
    //   read_only: readOnly,
    //   salon_website: salonWebsite,
    //   has_stripe_account: hasStripeAccount,
    // });

    // Link user to Segment
    window.analytics.identify(this.user.getID(), {
      name: stylistFullName,
      email: stylistEmail,
      app_version: appVersion,
      app_build_num: appBuildNum,
      company_name: salonName,
      has_calendar: user.getCalendar() === 1,
      hide_default_launcher: !user.getIsChatBubbleEnabled(),
      is_admin: user.isAdministrator(),
      can_view_all_calendars: user.getViewAllCalendars() === 1,
      can_view_all_clients: user.getViewAllClients() === 1,
      has_settings_control: user.getSettingsControl() === 1,
      requires_appt_confirmation: user.getConfirmApptsManually() === 1,
      time_zone: timeZone,
      country: country,
      read_only: this.salon.isReadOnly(),
      salon_website: salonWebsite,
      has_stripe_account: this.salon.hasStripeAccount()
    })

    // Sentry.setUser({
    //   id: stylistID,
    //   email: stylistEmail,
    //   username: stylistFullName,
    // });

    if (Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) {
      this.platform.ready().then(() => {
        ;(async () => {
        try {
          console.log('[Intercom][Capacitor] registerIdentifiedUser start')
          await Intercom.registerIdentifiedUser({
            userId: this.user.getID() + '',
            email: stylistEmail
          })
          console.log('[Intercom][Capacitor] registerIdentifiedUser done')
        } catch (err) {
          console.error('[Intercom][Capacitor] registerIdentifiedUser error', err)
        }

        try {
          if (this.user?.intercomUserHash) {
            console.log('[Intercom][Capacitor] setUserHash start')
            await Intercom.setUserHash({ hmac: this.user.intercomUserHash })
            console.log('[Intercom][Capacitor] setUserHash done')
          } else {
            console.warn('[Intercom][Capacitor] setUserHash skipped (no HMAC)')
          }
        } catch (err) {
          console.error('[Intercom][Capacitor] setUserHash error', err)
        }

        try {
          console.log('[Intercom][Capacitor] updateUser start')
          await Intercom.updateUser({
            name: stylistFullName,
            customAttributes: {
              has_calendar: hasCalendar,
              is_admin: isAdmin,
              can_view_all_calendars: canViewAllCalendars,
              can_view_all_clients: canViewAllClients,
              has_settings_control: hasSettingsControl,
              requires_appt_confirmation: requiresApptConfirmation,
              app_version: appVersion,
              app_build_num: appBuildNum,
              hide_default_launcher: !user.getIsChatBubbleEnabled(),
              // Flatten company attributes for native SDK (no nested objects)
              company_name: salonName,
              company_id: this.salon.getId(),
              company_time_zone: timeZone,
              company_country: country,
              company_read_only: readOnly,
              company_website: salonWebsite,
              company_email: this.salon.getEmail(),
              company_has_stripe_account: hasStripeAccount
            }
          })
          console.log('[Intercom][Capacitor] updateUser done')
        } catch (err) {
          console.error('[Intercom][Capacitor] updateUser error', err)
        }

        try {
          const displayIntercomStr = localStorage.getItem('displayIntercom')
          const showLauncher =
            displayIntercomStr === null ? true : displayIntercomStr === 'true'
          console.log('[Intercom][Capacitor] launcher preference', {
            displayIntercomStr,
            showLauncher
          })
          if (showLauncher) {
            await Intercom.displayLauncher()
          } else {
            await Intercom.hideLauncher()
          }
          await Intercom.setBottomPadding({ value: '100' })
        } catch (err) {
          console.error('[Intercom][Capacitor] launcher/padding error', err)
        }
        })()
      })
    }

    // Initialize Chatwoot on first login
    this.initializeChatwoot()

    if (window && window['Intercom']) {
      const intercom = window['Intercom']

      const displayIntercomStr = localStorage.getItem('displayIntercom')
      let displayIntercom =
        displayIntercomStr !== null ? displayIntercomStr === 'true' : false

      intercom('boot', {
        app_id: 'p3f80lct',
        user_id: this.user.getID() + '',
        email: stylistEmail,
        user_hash: this.user.intercomUserHash,
        name: stylistFullName,
        company: {
          name: salonName,
          id: this.salon.getId(),
          time_zone: timeZone,
          country: country,
          read_only: readOnly,
          salon_website: salonWebsite,
          salon_email: this.salon.getEmail(),
          Has_stripe_account: hasStripeAccount
        },
        // created_at: localStorage.getItem('creation_date'),
        has_calendar: hasCalendar,
        is_admin: isAdmin,
        can_view_all_calendars: canViewAllCalendars,
        can_view_all_clients: canViewAllClients,
        has_settings_control: hasSettingsControl,
        requires_appt_confirmation: requiresApptConfirmation,
        app_version: appVersion,
        app_build_num: appBuildNum,
        hide_default_launcher: displayIntercom
      })
    }
  }

  public isLoggedIn (): boolean {
    return this.loggedIn
  }

  /**
   * Ensure Intercom is initialized on Capacitor for the current logged-in user.
   * Useful on cold app start when a previous session is restored without an explicit login flow.
   */
  public initializeIntercomForCurrentUser (): void {
    if (!(Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova'))) {
      return
    }
    if (!this.isLoggedIn() || !this.user || !this.salon) {
      return
    }

    const user = this.user
    const salon = this.salon
    const stylistFullName = user.getFirstName() + ' ' + user.getLastName()
    const stylistEmail = user.getEmail()
    const appVersion = salon.getAppVersion()
    const appBuildNum = ENV_CONFIG.appVersion
    const salonName = salon.getName()
    const hasCalendar = user.getCalendar() === 1 ? 'Yes' : 'No'
    const isAdmin = user.isAdministrator() ? 'Yes' : 'No'
    const canViewAllCalendars = user.getViewAllCalendars() === 1 ? 'Yes' : 'No'
    const canViewAllClients = user.getViewAllClients() === 1 ? 'Yes' : 'No'
    const hasSettingsControl = user.getSettingsControl() === 1 ? 'Yes' : 'No'
    const requiresApptConfirmation =
      user.getConfirmApptsManually() === 1 ? 'Yes' : 'No'
    const timeZone = salon.getTimeZone()
    const country = salon.getCountry() ? salon.getCountry().getCountryName() : ''
    const readOnly = salon.isReadOnly() ? 'Yes' : 'No'
    const salonWebsite = salon.getWebsite()
    const hasStripeAccount = salon.hasStripeAccount() ? 'Yes' : 'No'

    ;(async () => {
      try {
        console.log('[Intercom][Capacitor:init] registerIdentifiedUser start')
        await Intercom.registerIdentifiedUser({
          userId: user.getID() + '',
          email: stylistEmail
        })
        console.log('[Intercom][Capacitor:init] registerIdentifiedUser done')
      } catch (err) {
        console.error(
          '[Intercom][Capacitor:init] registerIdentifiedUser error',
          err
        )
      }

      try {
        if (user?.intercomUserHash) {
          console.log('[Intercom][Capacitor:init] setUserHash start')
          await Intercom.setUserHash({ hmac: user.intercomUserHash })
          console.log('[Intercom][Capacitor:init] setUserHash done')
        } else {
          console.warn('[Intercom][Capacitor:init] setUserHash skipped (no HMAC)')
        }
      } catch (err) {
        console.error('[Intercom][Capacitor:init] setUserHash error', err)
      }

      try {
        console.log('[Intercom][Capacitor:init] updateUser start')
        await Intercom.updateUser({
          name: stylistFullName,
          customAttributes: {
            has_calendar: hasCalendar,
            is_admin: isAdmin,
            can_view_all_calendars: canViewAllCalendars,
            can_view_all_clients: canViewAllClients,
            has_settings_control: hasSettingsControl,
            requires_appt_confirmation: requiresApptConfirmation,
            app_version: appVersion,
            app_build_num: appBuildNum,
            hide_default_launcher: !user.getIsChatBubbleEnabled(),
            // Flatten company attributes for native SDK (no nested objects)
            company_name: salonName,
            company_id: salon.getId(),
            company_time_zone: timeZone,
            company_country: country,
            company_read_only: readOnly,
            company_website: salonWebsite,
            company_email: salon.getEmail(),
            company_has_stripe_account: hasStripeAccount
          }
        })
        console.log('[Intercom][Capacitor:init] updateUser done')
      } catch (err) {
        console.error('[Intercom][Capacitor:init] updateUser error', err)
      }

      try {
        const displayIntercomStr = localStorage.getItem('displayIntercom')
        const showLauncher =
          displayIntercomStr === null ? true : displayIntercomStr === 'true'
        console.log('[Intercom][Capacitor:init] launcher preference', {
          displayIntercomStr,
          showLauncher
        })
        if (showLauncher) {
          await Intercom.displayLauncher()
        } else {
          await Intercom.hideLauncher()
        }
        await Intercom.setBottomPadding({ value: '100' })
      } catch (err) {
        console.error('[Intercom][Capacitor:init] launcher/padding error', err)
      }
    })()
  }

  public getLogInMonitor (): Observable<boolean> {
    return this.logInMonitor$
  }

  public getLogOutMonitor (): Observable<boolean> {
    return this.logOutMonitor$
  }

  public getSessionMonitor (): Observable<Auth> {
    return this.sessionMonitor$
  }

  public logout () {
    if ((Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) && this.isLoggedIn()) {
      this.oneSignal.deleteTag('stylistID')
    }

    this.clearSession()

    // clear posthog session
    // posthog.reset();

    // clear chatwoot session
    if (window && window.$chatwoot) {
      window.$chatwoot.reset()
    }

    // clear intercom session
    if (window && window['Intercom']) {
      const intercom = window['Intercom']
      intercom('shutdown')
    }

    if (Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) {
      Intercom.logout()
    }

    // broadcast log out status
    this.logOutMonitor.next(true)
  }

  public clearSession () {
    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        localStorage.removeItem('auth')
        localStorage.removeItem('token')
        localStorage.removeItem('userID')
        localStorage.removeItem('stylistID')
        localStorage.removeItem('salonID')
        localStorage.removeItem('administrator')
        localStorage.removeItem('user')
        localStorage.removeItem('salon')
      } catch (err) {
        console.error('Error clearing localStorage:', err)
      }
    }
    this.clear()
  }

  public getUser (): Stylist {
    return this.user
  }

  public setUser (user: Stylist) {
    this.user = user
    if (Utilities.isHTM5LocalStorageSupported()) {
      localStorage.setItem('user', JSON.stringify(user.serialize()))
    }
  }

  public getSalon (): Salon {
    return this.salon
  }

  public setSalon (salon: Salon) {
    this.salon = salon
    if (Utilities.isHTM5LocalStorageSupported()) {
      localStorage.setItem('salon', JSON.stringify(this.salon.serialize()))
    }
  }

  public getToken (): string | undefined {
    return this.token
  }

  private clear () {
    this.loggedIn = false
    this.user = undefined
    this.salon = undefined
    this.token = undefined

    if (window && window['Intercom']) {
      const intercom = window['Intercom']
      intercom('shutdown')
    }

    if (Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) {
      Intercom.logout()
    }
  }

  public showIntercomChatBubble (): boolean {
    const hide = localStorage.getItem('hideHelpChatBubble')

    if (hide === 'true') {
      return false
    } else {
      return true
      // }
    }

    // return hidden;
  }

  public getSideBarVisibility (): boolean {
    return this.isSideBarShowing
  }

  public setSideBarVisiblity (visible: boolean) {
    this.isSideBarShowing = visible
  }

  public setHelpChatBubbleVisibility (show: boolean) {
    if (window && window['Intercom']) {
      const intercom = window['Intercom']
      intercom('update', {
        hide_default_launcher: !show
      })
    }
    if (Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) {
      if (show) {
        Intercom.displayLauncher()
      } else {
        Intercom.hideLauncher()
      }
    }
  }

  public updateLastActivity () {
    if (this.isLoggedIn()) {
      localStorage.setItem('loginLastRecorded', Date.now().toString())
    }
  }

  public refreshUserData () {
    // logger.info('refreshUserData in user.service.ts');
    if (this.isLoggedIn()) {
      const authStr = localStorage.getItem('auth')
      const userStr = localStorage.getItem('user')
      const salonStr = localStorage.getItem('salon')
      // logger.info('refreshUserData in user.service.ts', {
      //   authStr: authStr,
      //   userStr: userStr,
      //   salonStr: salonStr,
      // });
      if (authStr && userStr && salonStr) {
        const auth: Auth = JSON.parse(authStr)
        auth.user = JSON.parse(userStr)
        auth.salon = JSON.parse(salonStr)
        this.login(auth)
      } else {
        // logger.error(
        //   'No auth, user, or salon data found in refreshUserData in user.service.ts'
        // );
      }
    }
  }

  updateProfileImg (newData: any) {
    this.profileImageMonitor.next(newData)
  }

  /**
   * Initialize Chatwoot widget on first login
   * Sets up event listeners and initial user data
   */
  private initializeChatwoot () {
    if (!window || !this.isLoggedIn()) {
      return
    }

    // Set up Chatwoot event listeners for the ready event
    const setupChatwoot = () => {
      this.updateChatwootUser()
    }

    // Check if Chatwoot is already ready, otherwise listen for the ready event
    if (window.$chatwoot) {
      setupChatwoot()
    } else {
      // Listen for chatwoot:ready event as recommended in the documentation
      window.addEventListener('chatwoot:ready', setupChatwoot)
    }
  }

  /**
   * Update Chatwoot user data and custom attributes
   * Called whenever user or salon data changes via sessionMonitor
   */
  private updateChatwootUser () {
    if (
      !window ||
      !window.$chatwoot ||
      !this.isLoggedIn() ||
      !this.user ||
      !this.salon
    ) {
      return
    }

    console.log(
      'Updating Chatwoot user data',
      this.user.getID(),
      this.user.getPhotoUrl()
    )

    const user = this.user
    const salon = this.salon
    const stylistFullName = user.getFirstName() + ' ' + user.getLastName()
    const stylistEmail = user.getEmail()
    const appVersion = salon.getAppVersion()
    const appBuildNum = ENV_CONFIG.appVersion
    const salonName = salon.getName()
    const hasCalendar = user.getCalendar() === 1 ? 'Yes' : 'No'
    const isAdmin = user.isAdministrator() ? 'Yes' : 'No'
    const canViewAllCalendars = user.getViewAllCalendars() === 1 ? 'Yes' : 'No'
    const canViewAllClients = user.getViewAllClients() === 1 ? 'Yes' : 'No'
    const hasSettingsControl = user.getSettingsControl() === 1 ? 'Yes' : 'No'
    const requiresApptConfirmation =
      user.getConfirmApptsManually() === 1 ? 'Yes' : 'No'

    // Generate HMAC hash for identity validation
    const identifier = user.getID() + ''
    const identifierHash = Utilities.generateChatwootHMAC(
      identifier,
      ENV_CONFIG.CHATWOOT_HMAC_TOKEN
    )

    try {
      window.$chatwoot.setUser(identifier, {
        name: stylistFullName,
        avatar_url:
          ENV_CONFIG.STAFF_THUMBNAIL_PHOTO_ROOT + '/' + user.getPhotoUrl(),
        email: stylistEmail,
        identifier_hash: identifierHash,
        phone_number: user.getPhone2(),
        city: salon.getCity(),
        company_name: salonName
      })

      // Set custom attributes
      const customAttributes = {
        salonID: salon.getId(),
        pronouns: user.getPronoun() || '',
        title: user.getTitle() || '',
        hasCalendar: hasCalendar,
        isActive: user.isActive() ? 'Yes' : 'No',
        isAdmin: isAdmin,
        canViewAllCalendars: canViewAllCalendars,
        canViewAllClients: canViewAllClients,
        hasSettingsControl: hasSettingsControl,
        requiresApptConfirmation: requiresApptConfirmation,
        appVersion: appVersion || '',
        appBuildNum: appBuildNum || '',
        salonPhone: salon.getPhone() || '',
        statsLink:
          'https://salonmonster.com/internal/stats_detail.php?id=' +
          salon.getId(),
        salonWebsite: salon.getWebsite() || '',
        bookingLink: salon.getSubDomain() + '.salonmonster.com',
        creationDate: salon.getCreationDate() || '',
        timeZone: salon.getTimeZone() || '',
        country: salon.getCountry()?.getCountryName() || '',
        readOnly: salon.isReadOnly() ? 'Yes' : 'No'
      }

      console.log('Setting Chatwoot custom attributes:', customAttributes)
      window.$chatwoot.setCustomAttributes(customAttributes)

      console.log('Chatwoot user and custom attributes updated successfully')
    } catch (error) {
      console.error('Error updating Chatwoot user or custom attributes:', error)
    }
  }
}
